// src/services/makeupArtistService.ts
import api from "../api/axiosClient";

const BASE = "/MakeupArtist";

export const getMakeupArtists = async () => {
  const res = await api.get(BASE);
  return res.data;
};

export const getMakeupArtist = async (id: number) => {
  const res = await api.get(`${BASE}/${id}`);
  return res.data;
};

export const createMakeupArtist = async (data: any) => {
  const res = await api.post(BASE, data);
  return res.data;
};

export const updateMakeupArtist = async (id: number, data: any) => {
  const res = await api.put(`${BASE}/${id}`, data);
  return res.data;
};

export const deleteMakeupArtist = async (id: number) => {
  const res = await api.delete(`${BASE}/${id}`);
  return res.data;
};
